import React, { useState, useEffect } from "react";
import axios from "axios";
import "./Products.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faEye, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";
import { CSVLink } from "react-csv";
import { useNavigate } from "react-router-dom";

const Product = () => {
  const [products, setProducts] = useState([]);
  const [filteredProducts, setFilteredProducts] = useState([]);
  const [loading, setLoading] = useState(true); // ⬅️ Loading state
  const [currentPage, setCurrentPage] = useState(1);
  const productsPerPage = 10;
  const navigate = useNavigate();

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await axios.get("https://thbackend-lqde.onrender.com/api/products");
      // simulate delay of 2.5 seconds
      setTimeout(() => {
        setProducts(response.data);
        setFilteredProducts(response.data);
        setLoading(false);
      }, 2000);
    } catch (error) {
      console.error("❌ Error fetching products:", error);
      setLoading(false);
    }
  };

  const handleDelete = async (id) => {
    try {
      await axios.delete(`https://thbackend-lqde.onrender.com/api/products/${id}`);
      fetchProducts();
    } catch (error) {
      console.error("❌ Error deleting product:", error);
    }
  };

  const indexOfLastProduct = currentPage * productsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - productsPerPage;
  const displayedProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  const handleAddProduct = () => {
    navigate("/addproducts");
  };

  const handleViewAllProducts = () => {
    navigate("/products");
  };

  return (
    <div>
      {loading ? (
        <div className="spinner-container">
          <div className="spinner"></div>
          <p>Loading products...</p>
        </div>
      ) : (
        <>
          <div className="actionsbuttons">
            <CSVLink data={filteredProducts} filename={"products.csv"}>
              <FontAwesomeIcon icon={faDownload} className="view-icon" />
            </CSVLink>
            <FontAwesomeIcon icon={faPlus} onClick={handleAddProduct} className="view-icon" />
            <FontAwesomeIcon icon={faEye} onClick={handleViewAllProducts} className="view-icon" />
          </div>

          <table border="1">
            <thead>
              <tr>
                <th>Name</th>
                <th>Price</th>
                <th>Weight</th>
                <th>Image</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {displayedProducts.length > 0 ? (
                displayedProducts.map((product) => (
                  <tr key={product.id}>
                    <td>{product.name}</td>
                    <td>${product.price}</td>
                    <td>{product.weight}</td>
                    <td>
                      {product.image ? (
                        <img src={product.image} alt={product.name} width="50" height="50" />
                      ) : (
                        <img src="/placeholder.png" alt="placeholder" width="50" height="50" />
                      )}
                    </td>
                    <td>
                      <FontAwesomeIcon icon={faTrash} className="view-icon" onClick={() => handleDelete(product.id)} />
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="5">No products found</td>
                </tr>
              )}
            </tbody>
          </table>

          <div className="pagination">
            <button onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))}>Prev</button>
            <h6>
              Page {currentPage} of {Math.ceil(filteredProducts.length / productsPerPage)}
            </h6>
            <button
              onClick={() => setCurrentPage((prev) => prev + 1)}
              disabled={currentPage >= Math.ceil(filteredProducts.length / productsPerPage)}
            >
              Next
            </button>
          </div>
        </>
      )}
    </div>
  );
};

export default Product;
